// extracted by mini-css-extract-plugin
export default {"list":"EgresosLista_list__QTTg4"};